module.exports = __webpack_public_path__ + "static/media/susan front copy.43535196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/susan front copy.jpg
// module id = 436
// module chunks = 0